import {
  aboutLink,
  contactLink,
  internshipLink,
  loginLink,
  profileLink,
  exploreLink,
  userInternshipsLink,
} from "./routes";
import {
  INTERNTYPE1,
  INTERNTYPE2,
  INTERNTYPE3,
  LOGINBUTTON,
  LOGOUTBUTTON,
  NBUTTON1,
  NBUTTON2,
  NBUTTON3,
  NBUTTON4,
  NBUTTON5,
  NBUTTON6,
  SIGNINBUTTON,
} from "./strings";
import ProfileIcon from "../images/profile-menu/user-profile.svg";
import InternshipIcon from "../images/profile-menu/laptop.svg";

const NavItemContent = {
  general: [
    {
      text: NBUTTON1,
      url: aboutLink,
    },
    {
      text: NBUTTON2,
      url: contactLink,
    },
  ],
  conditional: [
    {
      icon: InternshipIcon,
      text: NBUTTON4,
      url: userInternshipsLink,
    },
    {
      icon: ProfileIcon,
      text: NBUTTON5,
      url: profileLink,
    },
  ],
  dropdown: {
    text: NBUTTON3,
    content: [
      {
        text: INTERNTYPE1,
        url: `${internshipLink}#design`,
      },
      {
        text: INTERNTYPE2,
        url: `${internshipLink}#development`,
      },
      {
        text: INTERNTYPE3,
        url: `${internshipLink}#marketing`,
      },
      {
        text: NBUTTON6,
        url: exploreLink,
      },
    ],
  },
  login: {
    text: `${LOGINBUTTON} / ${SIGNINBUTTON}`,
    url: loginLink,
  },
  logout: {
    text: LOGOUTBUTTON,
  },
};

export default NavItemContent;
